<template>
  <!--  批量修改标签操作-->
  <el-dialog :visible.sync="modal.addPhotoVisible"
             :title="title"
             width="820px"
             center
             @open="openModal">
    <el-form :model="data"
             size="small">
      <el-form-item label="请选择相册：">
        <el-select v-model="albumId"
                   placeholder="请选择"
                   @change="selectalbum">
          <el-option v-for="item in photoOptions"
                     :key="item.id"
                     :label="item.name"
                     :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="checkedPhotos">
        <el-checkbox-group v-model="checkedPhotos"
                           @change="handleCheckedChange">
          <div class="photo-list">
            <div class="photo-item"
                 v-for="(item, index) in dataList"
                 :key="item.id">
              <div class="my-checkbox">
                <el-checkbox :label="index"><i></i></el-checkbox>
              </div>
              <div class="show-img">
                <el-image v-if="picType == 2"
                          fit="contain"
                          :src="item.pic + '?x-oss-process=video/snapshot,t_1,f_jpg,m_fast,ar_auto'"
                          :preview-src-list="[item.pic + '?x-oss-process=video/snapshot,t_1,f_jpg,m_fast,ar_auto']">
                </el-image>
                <el-image v-else
                          fit="contain"
                          :src="item.pic"
                          :preview-src-list="[item.pic]">
                </el-image>
              </div>
            </div>
          </div>
        </el-checkbox-group>
      </el-form-item>
    </el-form>
    <!-- 分页 -->
    <el-row type="flex"
            justify="end">
      <el-pagination background
                     @current-change="handleCurrentChange"
                     layout="total, sizes,prev, pager, next, jumper"
                     @size-change="handleSizeChange"
                     :page-sizes="[10, 20, 30]"
                     :page-size="listQuery.pageSize"
                     :current-page.sync="listQuery.pageNum"
                     :total="listQuery.total">
      </el-pagination>
    </el-row>
    <div slot="footer"
         class="dialog-footer">
      <el-button size="medium"
                 @click="modal.addPhotoVisible = false">取 消</el-button>
      <el-button size="medium"
                 type="primary"
                 @click="handleConfirm">确 认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { getAlbumList, getAlbumPicAll } from '@/api/productAlbum'

export default {
  name: "AddPhotoModal",
  props: {
    modal: Object
  },
  data () {
    return {
      title: '选择图片',
      photoOptions: [],
      data: {},
      albumId: null,
      checkedPhotos: [],
      dataList: [],
      picType: 1,
      listQuery: {
        pageSize: 10,
        pageNum: 1,
        total: 0
      }
    }
  },
  methods: {
    getAlbumList () {
      getAlbumList({
        userId: this.modal.mchtId || this.userId,
        pageSize: 1000,
        pageNum: 1
      }).then(res => {
        this.photoOptions = res.data.list
      })
    },
    // 打开弹窗回调
    openModal () {
      this.checkedPhotos = []
    },
    // 处理是否为多选
    handleCheckedChange (value) {
      if (value.length > 1 && this.modal.flag != 2) {
        this.checkedPhotos.splice(0, 1)
      }
    },
    // 查询图片列表
    getAlbumPicAll (value) {
      let params = {
        albumId: value,
        userId: this.modal.mchtId || this.userId,
        pageSize: this.listQuery.pageSize,
        pageNum: this.listQuery.pageNum,
        pciType: this.picType || 1
      }
      getAlbumPicAll(params).then(res => {
        this.dataList = res.data.list
        this.listQuery.total = res.data.total
      })
    },
    // 选择相册
    selectalbum (value) {
      this.listQuery.pageNum = 1
      this.getAlbumPicAll(value)
    },
    // 确认
    handleConfirm () {
      let picUrls = []
      this.checkedPhotos.forEach(item => {
        picUrls.push(this.dataList[item].pic)
      })
      this.$emit('handlePhoto', picUrls, this.modal, this.picType)
    },
    handleSizeChange (val) {
      this.listQuery.pageNum = 1;
      this.listQuery.pageSize = val;
      this.getAlbumPicAll(this.albumId);
    },
    handleCurrentChange (val) {
      this.listQuery.pageNum = val;
      this.getAlbumPicAll(this.albumId);
    },
  },
  watch: {
    modal: {
      handler (newValue) {
        this.photoOptions = []
        this.albumId = null
        this.checkedPhotos = []
        this.dataList = []
        this.listQuery = {
          pageNum: 1,
          pageSize: 10,
          total: 0
        }
        this.modal = newValue
        if (this.modal.needVideo) {
          this.title = '选择视频'
          this.picType = 2
        } else {
          this.title = '选择图片'
          this.picType = 1
        }
        this.getAlbumList()
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters([
      'userId'
    ])
  }
}
</script>

<style lang="scss" scoped>
/*图片列表*/
.photo-list {
  font-size: 14px;
  padding: 15px 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  max-height: 30vh;
  overflow-y: auto;

  .photo-item {
    text-align: center;
    position: relative;
    width: 120px;
    margin: 15px;

    .show-img {
      .el-image {
        height: 168px;
      }
      height: 168px;
      background: whitesmoke;
    }

    .my-checkbox {
      position: absolute;
      top: 5px;
      left: 5px;
    }
  }
}

.my-checkbox {
  position: absolute;
  top: 5px;
  left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/pms/components/AddPhotoModal.vue